/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RevertBedChangeEligibilityResponse } from './RevertBedChangeEligibilityResponse';
import {
    RevertBedChangeEligibilityResponseFromJSON,
    RevertBedChangeEligibilityResponseFromJSONTyped,
    RevertBedChangeEligibilityResponseToJSON,
} from './RevertBedChangeEligibilityResponse';

/**
 * 
 * @export
 * @interface CheckRevertBedChangeEligibility200Response
 */
export interface CheckRevertBedChangeEligibility200Response {
    /**
     * 
     * @type {RevertBedChangeEligibilityResponse}
     * @memberof CheckRevertBedChangeEligibility200Response
     */
    data?: RevertBedChangeEligibilityResponse;
}

/**
 * Check if a given object implements the CheckRevertBedChangeEligibility200Response interface.
 */
export function instanceOfCheckRevertBedChangeEligibility200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CheckRevertBedChangeEligibility200ResponseFromJSON(json: any): CheckRevertBedChangeEligibility200Response {
    return CheckRevertBedChangeEligibility200ResponseFromJSONTyped(json, false);
}

export function CheckRevertBedChangeEligibility200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckRevertBedChangeEligibility200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : RevertBedChangeEligibilityResponseFromJSON(json['data']),
    };
}

export function CheckRevertBedChangeEligibility200ResponseToJSON(value?: CheckRevertBedChangeEligibility200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': RevertBedChangeEligibilityResponseToJSON(value.data),
    };
}

